import { render, staticRenderFns } from "./BoxInfoPatient.vue?vue&type=template&id=1924d7a7&scoped=true&"
import script from "./BoxInfoPatient.vue?vue&type=script&lang=js&"
export * from "./BoxInfoPatient.vue?vue&type=script&lang=js&"
import style0 from "./BoxInfoPatient.vue?vue&type=style&index=0&id=1924d7a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1924d7a7",
  null
  
)

export default component.exports